var $e201f176476caeac$exports = {};
$e201f176476caeac$exports = {
    "colorFormat": `Format koloru`,
    "hex": `Szesnastkowy`,
    "hsb": `HSB`,
    "hsl": `HSL`,
    "rgb": `RGB`
};


export {$e201f176476caeac$exports as default};
//# sourceMappingURL=pl-PL.mjs.map
